export default __webpack_public_path__ + "b811bf1e1021b2a2907293d386281e5b.png";